import { render } from "./PageProjects.vue?vue&type=template&id=062fac75"
import script from "./PageProjects.vue?vue&type=script&lang=js"
export * from "./PageProjects.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__